export default __webpack_public_path__ + "static/media/templateExpand.20a2891e.svg";